import { HTTP } from "@/api/http-common";
import ENDPOINT from "@/api/endpoints";

export function callApiDangNhap(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(ENDPOINT.AUTH.DANG_NHAP, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiRefreshToken(payload) {
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = {};
    return HTTP.post(ENDPOINT.AUTH.REFRESH_TOKEN, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiGetPermission(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.GET_PERMISSION, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiSyncData() {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.APP.SYNC_DATA)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function callApiLayTinhThanh(payload) {
  return HTTP({
    url: ENDPOINT.DANH_MUC.TINH_THANH,
    method: "GET",
    params: payload
  });
}

export function callApiLayDanhSachLevel() {
  return HTTP({
    url: ENDPOINT.DANH_MUC.LEVEL,
    method: "GET"
  });
}


export function callApiChangeGenerateSetupCode(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.GENERATE_SETUP_CODE_2FA, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}

export function callApiConfirmUsing(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.CONFIRM_USING_2FA, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}

export function callApiValidateLogin(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.VALIDATE_2FA, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
  });
}
